import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  CreateAccessControl,
  createProjectDocumentCustomAccessControls,
  deleteProjectDocumentCustomAccessControl,
  getProjectDocumentCustomAccessControls
} from '../../api/project-document-custom-access-controls';

export const getProjectDocumentCustomAccessControlsAsync = createAsyncThunk(
  'projectDocumentCustomAccessControls/getProjectDocumentCustomAccessControls',
  getProjectDocumentCustomAccessControls
);

export const createProjectDocumentCustomAccessControlsAsync = createAsyncThunk(
  'projectDocumentCustomAccessControls/createProjectDocumentCustomAccessControls',
  async (createAccessControls: CreateAccessControl, thunkAPI) => {
    const projectDocumentCustomAccessControl =
      await createProjectDocumentCustomAccessControls(createAccessControls);
    thunkAPI.dispatch(
      getProjectDocumentCustomAccessControlsAsync(
        createAccessControls.projectDocumentId
      )
    );
    return projectDocumentCustomAccessControl;
  }
);

export const deleteProjectDocumentCustomAccessControlAsync = createAsyncThunk(
  'projectDocumentCustomAccessControls/deleteProjectDocumentCustomAccessControl',
  async (
    {
      projectDocumentCustomAccessControlId,
      projectDocumentId
    }: {
      projectDocumentCustomAccessControlId: number;
      projectDocumentId: number;
    },
    thunkAPI
  ) => {
    await deleteProjectDocumentCustomAccessControl(
      projectDocumentCustomAccessControlId
    );
    thunkAPI.dispatch(
      getProjectDocumentCustomAccessControlsAsync(projectDocumentId)
    );
  }
);

export interface ProjectDocumentCustomAccessControl {
  id: number;
  userId: number;
  projectDocumentId: number;
}

interface ProjectDocumentCustomAccessControlState {
  data: ProjectDocumentCustomAccessControl[];
}

const initialState: ProjectDocumentCustomAccessControlState = {
  data: []
};

export default createSlice({
  name: 'projectDocumentCustomAccessControls',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getProjectDocumentCustomAccessControlsAsync.fulfilled,
      (state, action) => {
        state.data = action.payload.data;
      }
    );
  }
});
